export default __webpack_public_path__ + "static/pie-in-a-doughnut-0ffd49e7229c0ebbc2ddf1c95973b361.png";